// extracted by mini-css-extract-plugin
export default {"qa":"FaqCard_qa__mj5Z5","card":"FaqCard_card__xq6dC"};